// token
export const TOKEN = 'token';

// deviceID
export const DEVICE_ID = 'deviceID';

// question id  created when non-login
export const QUESTION_ID = 'QUESTION_ID';

export const PREVIOUS_PURCHASE_PAGE = 'PREVIOUS_PURCHASE_PAGE';

export const IS_WIZMO_USER = 'isWizmoUser';

export const PREVIOUS_SSO_LOGIN_PAGE = 'PREVIOUS_SSO_LOGIN_PAGE';



// WEBPACK FOOTER //
// ./app/constants/cookieNames.js